/*eslint-disable */
export default {
  service: {
    game: {
      name: 'Dịch Vụ Game',
      description: 'Dịch Vụ Game'
    },
    stream: {
      name: 'Dịch Vụ Stream',
      description: 'Dịch Vụ Stream'
    },
    user: {
      name: 'Dịch Vụ Người Dùng',
      description: 'Dịch Vụ Người Dùng'
    },
    admin: {
      name: 'Dịch Vụ Quản Trị',
      description: 'Dịch Vụ Quản Trị'
    },
    wallet: {
      name: 'Dịch Vụ Ví',
      description: 'Dịch Vụ Ví'
    },
    setting: {
      name: 'Cài Đặt',
      description: 'Cài Đặt'
    },
    login: {
      logout: 'Đăng Xuát'
    }
  },
  setting: {
    title: 'Cài Đặt FLive',
    language: 'Ngôn Ngữ'
  },
  game: {
    game: {
      title: 'Quản Lý Game'
    }
  },
  stream: {
    category: {
      title: 'Quản Lý Category',
      table: {
        info: 'Thông Tin',
        icon: 'Icon',
        status: 'Trạng Thái',
        numberLiveStream: 'Số Livestream'
      },
      filter: {
        status: 'Trạng Thái'
      },
      button: {
        new: 'Thêm',
        cancel: 'Huỷ',
        save: 'Lưu',
        chooseFile: 'Chọn File'
      },
      form: {
        titleAdd: 'Thêm Mới Danh Mục',
        titleEdit: 'Cập Nhập Danh Mục',
        titleAddChild: 'Thêm Mới Danh Mục Con',
        name: 'Tên',
        vn: 'Tiếng Viết',
        en: 'Tiếng Anh',
        description: 'Mô Tả',
        status: 'Trạng Thái',
        icon: 'Icon',
        start: 'Bắt Đầu',
        end: 'Kết Thúc',
        center: 'Giữa',
        radius: 'Bán Kính',
        uploadIcon: 'Tải Icon'
      }
    },
    live: {
      title: 'Quản Lý Live',
      table: {
        stt: 'STT',
        banner: 'Ảnh',
        titleLiveStream: 'Tiêu Đề',
        status: 'Trạng Thái',
        infoView: 'Thông Tin Lượt Xem',
        category: 'Danh Mục',
        resolution: 'Độ Phân Giải',
        action: 'Hành Động',
        history: 'Lịch Sử'
      },
      button: {
        chooseFile: 'Chọn File',
        cancel: 'Huỷ',
        save: 'Lưu',
        block: 'Chặn'
      },
      form: {
        userID: 'Người dùng ID',
        accountName: 'Tên Tài Khoản :',
        title: 'Tiêu Đề',
        category: 'Danh Mục',
        fakeView: 'Lượt Xem Ảo',
        banner: 'Ảnh',
        blockTitle: 'Chặn Livestream',
        reason: 'Lý Do'
      },
      filter: {
        keyword: 'Từ Khoá',
        date: 'Thời Gian',
        status: 'Trạng Thái'
      },
      detail: {
        titleHeader: 'Chi Tiết Live',
        title: 'Tiêu Đề',
        fakeView: 'Lượt Xem Ảo',
        view: 'Lượt Xem',
        totalView: 'Tổng Lượt Xem',
        startTime: 'Thời Gian Bắt Đầu',
        endTime: 'Thời Gian Kết Thúc',
        gift: 'Quà Tặng',
        diamond: 'Kim Cương',
        roses: 'Hoa Hồng',
        banner: 'Ảnh',
        hot: 'Hot',
        type: 'Loại',
        resolution: 'Độ phân giải'
      },
      history: {
        title: 'Lịch Sử LiveStream',
        filter: {
          date: 'Thời Gian',
          status: 'Trạng Thái'
        },
        table: {
          stt: 'Stt',
          Title: 'Tiêu Đề',
          category: 'Danh Mục',
          liveSessionId: 'Phiên Live ID',
          time: 'Thời Gian',
          video: 'Video',
          status: 'Trạng Thái',
          action: 'Hành Động'
        },
        detail: {
          title: 'Phiên Live Chi Tiết',
          liveSessionId: 'Phiên Live ID ',
          userId: 'Người Dùng ID',
          viewHigh: 'Lượt Xem Cao Nhất',
          totalCoin: 'Tổng Xu :',
          totalDiamond: 'Tổng Kim Cương',
          reasonBlock: 'Lý Do Block'
        }
      }
    },
    config: {
      title: 'Quản Lý Config'
    },
    gift: {
      title: 'Quản Lý Gift',
      table: {
        category: 'Danh Mục',
        name: 'Tên',
        image: 'Ảnh',
        animation: 'Hiệu Ứng',
        infoGift: 'Thông Tin Quà',
        price: 'Giá',
        status: 'Trạng Thái',
        action: 'Hành Động'
      },
      button: {
        chooseAnimation: 'Tải Hiệu Ứng',
        chooseFile: 'Tải File',
        new: 'Thêm',
        cancel: 'Huỷ',
        save: 'Lưu'
      },
      filter: {
        currency: 'Loại Tiện',
        limitType: 'Loại Giới Hạn',
        status: 'Trạng Thái'
      },
      form: {
        titleAdd: 'Thêm Mới Quà Tặng',
        titleEdit: 'Cập Nhật Quà Tặng',
        name: 'Tên',
        description: 'Mô Tả',
        category: 'Danh Mục',
        status: 'Trạng Thái',
        cost: 'Giá Cả',
        value: 'Giá Trị',
        type: 'Loại',
        limitType: 'Loại Giới Hạn',
        icon: 'Icon'
      }
    },
    giftCategory: {
      title: 'Quản Lý  Gift Category',
      table: {
        name: 'Tên',
        status: 'Trạng Thái'
      },
      button: {
        new: 'Thêm',
        cancel: 'Huỷ',
        save: 'Lưu'
      },
      filter: {
        status: 'Trạng Thái'
      },
      form: {
        titleAdd: 'Thêm Mới Danh Mục',
        tilteEdit: 'Cập Nhập Danh Mục',
        name: 'Tên',
        sorting: 'Sắp Xếp',
        status: 'Trạng Thái'
      }
    },
    fanclub: {
      title: 'Quản Lý  FanClub ',
      table: {
        name: 'Tên Fanclub',
        totalMember: 'Tổng Thành Viên',
        actualLoyalty: 'Trung Thành Thực Tế',
        bonusLoyalty: 'Thưởng Trung Thành',
        displayLoyalty: 'Tổng Trung Thành',
        status: 'Trạng Thái',
        createdTime: 'Khởi Tạo',
        action: 'Hành Động'
      },
      button: {
        cancel: 'Huỷ',
        save: 'Lưu',
        inactive: 'Không Hoạt Động',
        editBonus: 'Cập Nhập Thưởng'
      },
      filter: {
        keyword: 'Từ Khoá',
        status: 'Trạng Thái'
      },
      form: {
        tilte: 'Cập Nhập Thưởng Trung Thành',
        value: 'Giá Trị'
      }
    },
    levelMission: {
      title: 'Cấp Độ & Nhiệm Vụ '
    },
    level: {
      title: 'Quản Lý Level',
      table: {
        level: 'Cấp Độ',
        levelIcon: 'Icon Cấp Độ',
        badge: 'Huy Hiệu',
        exp: 'Kinh Nghiệm',
        type: 'Loại',
        loyalty: 'Trung Thành',
        reduce_loyalty: 'Giảm lòng trung thành',
        daily_gift: 'Quà Hằng Ngày',
        update: 'Cập Nhật',
        operation: 'Hành Động'
      },
      filter: {
        type: 'Loại'
      },
      button: {
        chooseFile: 'Chọn File',
        cancel: 'Huỷ',
        save: 'Lưu',
        new: 'Thêm'
      },
      form: {
        titleAdd: 'Tạo Mới Cấp Độ',
        titleEdit: 'Cập Nhập Cấp Độ',
        type: 'Loại',
        loyalty: 'Độ Trung Thành',
        level: 'Cấp Độ',
        reduceLoyalty: 'Giảm lòng trung thành',
        dailyGift: 'Quả Hằng Ngày',
        quantity: 'Định Lượng',
        gift: 'Quà',
        expValue: 'Kinh Nghiệm',
        badge: 'Huy Hiệu'
      }
    },
    mission: {
      title: 'Quản Lý  Mission',
      table: {
        quest_id: 'ID',
        quest: 'Nhiệm Vụ',
        quest_description: 'Mô Tả',
        exp: 'Kinh Nghiệm',
        time_day: 'Số Lần/Ngày',
        role: 'Vai Trò',
        limit: 'Giới Hạn',
        loyalty: 'Trung Thành',
        time: 'Số Lần',
        status: 'Trạng Thái',
        action: 'Hành Động'
      },
      button: {
        chooseFile: 'Choose File',
        cancel: 'Huỷ',
        save: 'Lưu',
        new: 'Thêm',
        active: 'Kích hoạt',
        inactive: 'Không Kích Hoạt'
      },
      filter: {
        role: 'Quyền'
      },
      form: {
        titleAdd: 'Tạo mới Mission',
        titleEdit: 'Cập Nhập Mission',
        name: 'Tên',
        loyalty: 'Độ Trung Thành',
        description: 'Mô Tả',
        exp: 'Kinh Nghiệm',
        timeDay: 'Số Lần / Ngày',
        role: 'Quyền',
        limit: 'Giới Hạn'
      }
    },
    beautyEffect: {
      title: 'Quản Lý Beauty Effect',
      button: {
        uploadFile: 'Tải File',
        inactive: 'Không Hoạt Động',
        active: 'Hoạt Động'
      },
      table: {
        stt: 'stt',
        link: 'Link Tải Xuống',
        status: 'Trạng Thái',
        version: 'Phiên Bản',
        operation: 'Hành Động'
      }
    },
    campaign: {
      title: 'Quản Lý Chiến Dịch',
      button: {
        uploadFile: 'Tải File',
        inactive: 'Không Hoạt Động',
        active: 'Hoạt Động'
      },
      table: {
        stt: 'stt',
        link: 'Link Download',
        status: 'Trạng Thái',
        version: 'Phiên Bản',
        operation: 'Hành Động'
      }
    }
  },
  admin: {
    adminManagement: {
      title: 'Quản Lý Admin',
      filter: {
        keyword: 'Từ khoá',
        status: 'Trạng Thái',
        cancel: 'Huỷ',
        save: 'Lưu'
      },
      button: {
        actived: 'Kích Hoạt',
        deleted: 'Xoá',
        invite: 'Mời',
        new: 'Thêm'
      },
      table: {
        name: 'Tên',
        role: 'Quyền',
        status: 'Trạng Thái',
        action: 'Hành Động'
      },
      form: {
        name: 'Tên',
        password: 'Mật Khẩu',
        role: 'Quyền'
      }
    },
    roleManagement: {
      title: 'Quản Lý Phân Quyền',
      filter: {
        keyword: 'Từ Khoá',
        cancel: 'Huỷ',
        save: 'Lưu'
      },
      button: {
        new: 'Thêm',
        editResource: 'Sửa Tài Nguyên',
        addResource: 'Tài Nguyên'
      },
      table: {
        name: 'Tên',
        code: 'Mã',
        status: 'Trạng Thái',
        action: 'Hành Động'
      },
      form: {
        titleAdd: 'Thêm Mới Phân Quyền',
        titleEdit: 'Sửa Phân Quyền',
        name: 'Tên',
        code: 'Mã',
        role: 'Quyền'
      }
    },
    permissionManagement: {
      title: 'Quản Lý Sự Cho Phép',
      filter: {
        status: 'Trạng Thái',
        keyword: 'Từ Khoá',
        cancel: 'Huỷ',
        save: 'Lưu'
      },
      button: {
        new: 'Thêm'
      },
      table: {
        name: 'Tên',
        code: 'Mã',
        status: 'Trạng Thái',
        action: 'Hành Động'
      },
      form: {
        titleAdd: 'Thêm Mới Sự Cho Phép',
        titleEdit: 'Sửa Sự Cho Phép',
        name: 'Tên',
        code: 'Mã',
        status: 'Trạng Thái'
      }
    },
    resourceManagement: {
      title: 'Quản Lý Tài Nguyên',
      filter: {
        status: 'Trạng Thái',
        keyword: 'Từ Khoá',
        cancel: 'Huỷ',
        save: 'Lưu'
      },
      button: {
        new: 'Thêm'
      },
      table: {
        name: 'Tên',
        code: 'Mã',
        path: 'Đường Dẫn',
        status: 'Trạng Thái',
        action: 'Hành Động'
      },
      form: {
        titleAdd: 'Thêm Mới Tài Nguyên',
        titleEdit: 'Sửa Tài Nguyên',
        path: 'Đường Dẫn',
        name: 'Tên',
        code: 'Mã',
        status: 'Trạng Thái'
      }
    }
  },
  wallet: {
    bank: {
      title: 'Quản Lý Ngân Hàng',
      filter: {
        keyword: 'Từ Khoá'
      },
      dialogDelete: {
        header: 'Xác Nhận Xoá Bản Ghi',
        message: 'Bạn có muốn xoá bản ghi ? '
      },
      button: {
        new: 'Thêm',
        cancel: 'Huỷ',
        save: 'Lưu'
      },
      table: {
        stt: 'Stt',
        name: 'Tên',
        code: 'Mã',
        icon: 'Ảnh',
        status: 'Trạng Thái',
        action: 'Hành Động'
      },
      form: {
        titleAdd: 'Thêm Ngân Hàng',
        titleEdit: 'Sửa Ngân Hàng',
        name: 'Hành Động',
        code: 'Mã',
        icon: 'Ảnh',
        chooseFile: 'Chọn Tệp'
      }
    },
    bankBranch: {
      title: 'Quản Lý Chi Nhánh Ngân Hàng',
      name: 'Tên',
      code: 'Mã',
      banner: 'Ảnh',
      dialogDelete: {
        header: 'Xác Nhận Xoá Bản Ghi',
        message: 'Bạn có muốn xoá bản ghi ? '
      },
      button: {
        new: 'Thêm',
        cancel: 'Huỷ',
        save: 'Lưu'
      },
      table: {
        name: 'Tên',
        action: 'Hành Động'
      },
      form: {
        titleAdd: 'Tạo Chi Nhánh Ngân Hàng',
        titleEdit: 'Sửa Chi Nhánh Ngân Hàng',
        name: 'Tên'
      }
    },
    consumptions: {
      title: 'Quản Lý Tiêu Thụ',
      filter: {
        senderID: 'ID Người Gửi',
        receiverID: 'ID Người Nhận',
        date: 'Thời Gian',
        limitType: 'Loại giới hạn',
        currency: 'Loại Tiền',
        keyword: 'Từ Khoá'
      },
      table: {
        stt: 'Stt',
        giftName: 'Tên Quà',
        senderID: 'ID Người Gửi',
        receiverID: 'ID Người Nhận',
        limitType: 'Loại giới hạn',
        currency: 'Loại Tiền',
        count: 'Số Lần',
        cost: 'Giá',
        time: 'Thời Gian'
      }
    },
    product: {
      title: 'Sản Phẩm'
    },
    orderTopUp: {
      title: 'Quản Lý Nạp Tiền',
      filter: {
        transID: 'ID Giao Dịch',
        userID: 'ID Người Dùng',
        date: 'Thời Gian',
        payChannel: 'Kênh Thanh Toán',
        status: 'Trạng Thái'
      },
      table: {
        transID: 'ID Giao Dịch',
        userID: 'ID Người Dùng',
        date: 'Thời Gian',
        cost: 'Giá',
        time: 'Thời Gian',
        currency: 'Tiền Tệ',
        amount: 'Tổng',
        payChannel: 'Kênh Thanh Toán',
        status: 'Trạng Thái'
      }
    }
  },
  user: {
    userManagement: {
      title: 'Quản Lý Người Dùng',
      filter: {
        status: 'Trạng Thái',
        keyword: 'Từ Khoá'
      },
      dialogDelete: {
        header: 'Xác Nhận Xoá Bản Ghi',
        message: 'Bạn có muốn xoá bản ghi ? '
      },
      button: {
        ban: 'Chặn',
        unban: 'Gỡ Chặn',
        reactivate: 'Kích Hoạt',
        delete: 'Xoá',
        new: 'Mới',
        cancel: 'Huỷ',
        save: 'Lưu'
      },
      table: {
        userID: 'Người Dùng ID',
        avatar: 'Ảnh Đại Diện',
        information: 'Thông Tin',
        infoAccount: 'Thông Tin Tài Khoản',
        balance: 'Tài Sản',
        status: 'Trạng Thái',
        action: 'Hành Động',
        username: 'Tên Người Dùng',
        gender: 'Giới Tính',
        male: 'Name',
        female: 'Nữ',
        userLevel: 'Cấp Độ Người Dùng',
        vipLevel: 'Cấp Độ VIP',
        register: 'Đăng Ký',
        lastLogin: 'Đăng Nhập Lần Cuối',
        logPlatform: 'Nền Tảng ',
        roses: 'Hoa Hồng',
        diamond: 'Kim Cương',
        ruby: 'Hồng Ngọc'
      },
      statusUser: {
        active: 'Kích Hoạt',
        block: 'Chặn',
        pending: 'Chờ',
        all: 'Tất cả trạng thái',
        deleted: 'Xoá'
      },
      form: {
        titleEdit: 'Cập Nhật Người Dùng',
        name: 'Tên Người Dùng',
        level: 'Cấp Độ',
        diamond: 'Kim Cương',
        roses: 'Hoa Hồng'
      }
    },
    notification: {
      title: 'Quản Lý Thông Báo',
      messVN: 'Thông Báo Tiếng Việt :',
      messEN: 'Thông Báo Tiếng Anh :',
      listUser: 'Danh Sách Người Dùng',
      button: {
        done: 'Hoàn Thành',
        send: 'Gửi',
        chooseUser: 'Chọn Người Dùng',
        selectAll: 'Chọn Tất Cả'
      },
      table: {
        userID: 'Người Dùng ID',
        avatar: 'Ảnh Đại Diện',
        information: 'Thông Tin',
        status: 'Trạng Thái',
        name: 'Tên'
      }
    }
  },
  alert: {
    roleButton: 'Không có quyền'
  }
}
